import { delData, getData, postData, putData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';
import { HomeProductType, FormHomeProductType, SortHomeProductPayload } from '../../../types/homeProduct';

export interface HomeProductRequestParams {
  take?: number;
  page?: number;
  country?: string;
  sort?: boolean;
}

export interface HomeProductTypeResponse {
  // eslint-disable-next-line camelcase
  overwrite_products: HomeProductType[];
  count: number;
}

interface SuccessResponse {
  success: boolean;
}

export const getHomeProductListRepository = async (
  data?: HomeProductRequestParams,
): Promise<HomeProductTypeResponse> => {
  const response = await getData<HomeProductRequestParams, HomeProductTypeResponse>(
    API_URLS.HOME_PRODUCT_DATA_API,
    data,
    undefined,
    undefined,
    { country: data?.country },
  );
  return response.data;
};

export const syncProductListFromEcomRepository = async (
  data?: HomeProductRequestParams,
): Promise<HomeProductTypeResponse> => {
  const response = await getData<HomeProductRequestParams, HomeProductTypeResponse>(
    API_URLS.HOME_PRODUCT_DATA_ECOM_API,
    undefined,
    undefined,
    undefined,
    { country: data?.country },
  );
  return response.data;
};

export const postCreateHomeProductRepository = async (payload: FormHomeProductType): Promise<void> => {
  await postData<FormHomeProductType, SuccessResponse>(API_URLS.HOME_PRODUCT_CREATE_API, payload);
};

export const patchUpdateHomeProductRepository = async (payload: HomeProductType): Promise<void> => {
  await putData<HomeProductType, SuccessResponse>(API_URLS.HOME_PRODUCT_UPDATE_API(payload?.id || ''), payload);
};

export const deleteHomeProductRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.HOME_PRODUCT_DELETE_API(id));
};

export const postSortHomeProductsRepository = async (payload: SortHomeProductPayload): Promise<void> => {
  await postData<SortHomeProductPayload, SuccessResponse>(API_URLS.HOME_PRODUCT_SORT_API, payload);
};
